@import './pk-empty-message.variables';

:host {
  @apply block;
}

.pk-empty-message__base {
  @apply flex flex-1 flex-col items-center justify-center rounded-[--empty-message--border-radius] p-[--empty-message--padding];
  @apply bg-[color:--empty-message--bg-color] bg-[image:--empty-message--bg-image] bg-cover bg-no-repeat;
  @apply text-[length:--empty-message--font-size] leading-[--empty-message--font-lh] text-[color:--empty-message--color];

  font-family: var(--empty-message--font-family);
}

::slotted([slot='title']) {
  @apply mb-[--empty-message--title-margin];
  font-family: var(--empty-message--title-font-family);
}

::slotted([slot='action']) {
  @apply mt-[--empty-message--action-margin] leading-[--empty-message--action-font-lh] text-[color:--empty-message--action-color];
  font-family: var(--empty-message--action-font-family);
}
